import React, { memo } from 'react';
import { Controller } from 'react-hook-form';
import { TextField, makeStyles } from '@material-ui/core';
import { COLOR_BORDER } from '../../styles/colors';
import { EvaluationFieldProps } from '../../types/Evaluation';
import Input from '../Input';

const useStyles = makeStyles(theme => ({
  textField: {
    width: '100%',
  },
}), { name: 'TextInput' });

function TextInput({ name, control, label }: EvaluationFieldProps) {
  const classes = useStyles();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value, ref } }) => (
        <Input 
            className={classes.textField} 
            label={label}
            value={value || ''}
            onChange={onChange}
            rows={2}
        />
        )}
    />
  );
}

export default memo(TextInput);
